/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { PrimaryButton } from "../../components";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import { BadgesTable } from "./BadgesTable";
import { useUserProfileBadges } from "../../store/useUserProfileBadges";

function UserProfileBadgesScreen() {
  /** Hooks */
  const navigate = useNavigate();
  const { getUserProfileBadges, userProfileBadges } = useUserProfileBadges();

  useEffect(() => {
    getUserProfileBadges();
  }, []);

  /** Functions */
  const addBadge = () => navigate("/add-user-profile-badge");
  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          User Profile Badges
        </h1>
        <PrimaryButton onClick={addBadge} label="Add new" className="h-10" />
      </div>
      <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
        {!userProfileBadges?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no user profile badge created yet.
          </p>
        ) : (
          <BadgesTable />
        )}
      </div>
    </div>
  );
}

export default withProtectedRoute(UserProfileBadgesScreen);
